import { searchBuyers } from '@/data/api/request/draftOrderRequests';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

export default function useSearchBuyers() {
  const [query, setQuery] = useState<string>('');

  const { data, isFetching, error } = useQuery({
    queryKey: ['searchBrands', query],
    queryFn: async () => {
      return await searchBuyers(query);
    },
    enabled: !!query.trim(),
  });

  return {
    data,
    isFetching,
    error,
    setQuery,
  };
}
